import React, { useState, useEffect } from 'react';

const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return { ...prev, seconds: prev.seconds - 1 };
        if (prev.minutes > 0) return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        if (prev.hours > 0) return { hours: prev.hours - 1, minutes: 59, seconds: 59 };
        return { hours: 0, minutes: 0, seconds: 0 };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const format = (num) => num.toString().padStart(2, '0');

  return (
    <div className="flex gap-4 items-center">
      <div className="flex flex-col items-center">
        <span className="text-4xl md:text-6xl font-black text-acid font-mono">{format(timeLeft.hours)}</span>
        <span className="text-xs text-[#737373] font-bold tracking-widest mt-1">HRS</span>
      </div>
      <span className="text-4xl md:text-6xl font-black text-[#333] mb-5">:</span>
      <div className="flex flex-col items-center">
        <span className="text-4xl md:text-6xl font-black text-acid font-mono">{format(timeLeft.minutes)}</span>
        <span className="text-xs text-[#737373] font-bold tracking-widest mt-1">MIN</span>
      </div>
      <span className="text-4xl md:text-6xl font-black text-[#333] mb-5">:</span>
      <div className="flex flex-col items-center">
        <span className="text-4xl md:text-6xl font-black text-acid font-mono">{format(timeLeft.seconds)}</span>
        <span className="text-xs text-[#737373] font-bold tracking-widest mt-1">SEC</span>
      </div>
    </div>
  );
};

export default Countdown;